var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookmarkSquareBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.75 0h32v32h-32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.75 4a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4h-16a4 4 0 0 1-4-4V8a4 4 0 0 1 4-4h16zm-1 18a1 1 0 0 1-1.447.894l-5.553-2.777-5.553 2.777a1 1 0 0 1-1.438-.758L9.75 22V6h-1a2 2 0 0 0-1.99 1.807L6.75 8v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-1v16zm-2-16h-10v14.381l4.553-2.275a1 1 0 0 1 .75-.06l.144.06 4.553 2.277V6z",
    fill: "#192340",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkSquareBlack);
export default __webpack_public_path__ + "static/media/bookmark-square-black.5694b8e4c2e8297cd9acfdfb310f8468.svg";
export { ForwardRef as ReactComponent };